// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jsf-control .form-control {
	padding: 5px 10px;
	height: auto;
}

.jsf-control-array-container {
  display: block;
}
.jsf-control-array-element {
  display: inline-block;
  width: 85%;
}
.jsf-control-array-element-delete {
  display: inline-block;
  position: relative;
  top: 20px;
}

.jsf-horizontal-layout > .jsf-horizontal-layout-container > div {
	padding: 10px;
}

.jsf-form .button {
	height: auto;
}
.jsf-form label-control {
	font-weight: 800;
}
.jsf-form input {
	max-width: 100%;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
